// @flow
import * as React from 'react';

import styled from 'styled-components';
import colors from '../../../assets/css/colors';

import ArrowDown from '../../../components/Icons/ArrowDown';
import Lock from '../../../components/Icons/Lock';
import { BorderedIcon } from "../../../components";

const SelectWrapper = styled.div`
	display: flex;
	position: relative;
	width: 100%;
	height: 38px;
	
	.arrow {
		position: absolute;
		top: 12px;
		right: 10px;
		pointer-events: none;
		color: ${({ color }) => color || colors.darkGrey};
		opacity: ${({ disabled }) => disabled ? '.5' : '1'};
	}
`;

const SelectItem = styled.select`
	color: ${({ color }) => color || colors.darkGrey};
	font-weight: bold;
	font-size: 12px;
	height: 38px;
	border: 1px solid ${colors.lightGrey};
	background-color: #FFFFFF;
	width: 100%;
	box-shadow: 2px 0 9px 2px #efeeee;
	padding-left: 1em;
	-webkit-appearance: none;
	-moz-appearance: none;
	outline: none;
	border-radius: 0;
	text-transform: uppercase;
	
	&:disabled {
		opacity: .5;
		margin-left: 1em;
	}
	
	&::-ms-expand {
	    display: none;
	}
`;

type Props = {
	input?: Object,
	rest?: Object,
	is_disabled?: boolean,
	color?:string
};

export const Select = ( { input, is_disabled, color, ...rest }: Props ) => (
	<SelectWrapper disabled={is_disabled} >
		{is_disabled ? (
			<BorderedIcon padding=".25em">
				<Lock size="2" />
			</BorderedIcon>
		) : ''}
		<SelectItem {...rest} disabled={is_disabled} color={color} />
		<ArrowDown className="arrow" color={color}/>
	</SelectWrapper>
);

export default Select;


// WEBPACK FOOTER //
// ./src/components/Form/Select/index.js